export default __webpack_public_path__ + "static/media/greed-regular.9d1e127c.otf";